import React from 'react';

const ErrorIcon = props => (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="32" cy="32" r="30" stroke="#EB264D" strokeWidth="4"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M24.0796 21.2528C23.2985 20.4717 22.0322 20.4717 21.2511 21.2528C20.4701 22.0338 20.4701 23.3002 21.2511 24.0812L29.1699 32L21.2511 39.9188C20.4701 40.6998 20.4701 41.9662 21.2511 42.7472C22.0322 43.5283 23.2985 43.5283 24.0796 42.7472L31.9984 34.8284L39.9178 42.7479C40.6988 43.5289 41.9652 43.5289 42.7462 42.7479C43.5273 41.9668 43.5273 40.7005 42.7462 39.9194L34.8268 32L42.7462 24.0806C43.5273 23.2995 43.5273 22.0332 42.7462 21.2521C41.9652 20.4711 40.6988 20.4711 39.9178 21.2521L31.9983 29.1716L24.0796 21.2528Z" fill="#EB264D"/>
    </svg>
);

export default ErrorIcon;